import React from 'react'
import PropTypes from 'prop-types'
import styles from '../RichTextEditor/richtexteditor.styl'
import { get } from 'lodash'

class RichTextEditor extends React.Component {
    static propTypes = {
        value: PropTypes.object,
        input: PropTypes.object,
        isInitialized: PropTypes.bool
    }

    static defaultProps = {
        value: '',
        isInitialized: false
    }

    state = {
        value: ''
    }

    constructor(props) {
        super(props)
        // this is solution because SSR caused problem with document not found/ready
        // when Quill is loaded
        if (typeof window !== 'undefined') {
            this.ReactQuill = require('react-quill')
            require('quill-emoji')
        }

        if(this.props.isInitialized){
            this.state = { value:this.props.value }
        } else {
            this.state = { value:'' }
        }
    }


    componentWillReceiveProps(nextProps) {
        if(this.props.value !== get(nextProps, 'value')){
            this.setState({value: get(nextProps, 'value')})
        }
    }

    render() {
        const { input } =  this.props

        const ReactQuill = this.ReactQuill

        const toolbarOptions = {
            container: [
                ['bold', 'italic', 'underline'],
                ['blockquote', 'code-block'],
                ['link'],
                [{ 'header': 1 }, { 'header': 2 }],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'align': [] }],
                ['emoji']
            ],
         /*   handlers: {'emoji': function() {}}*/
        }

        if (typeof window !== 'undefined' && ReactQuill) {
            return (
                <ReactQuill
                    className={styles.container}
                    value={this.state.value}
                    onChange={(newValue, delta, source) => {
                        if (source === 'user') {
                            this.setState({value: newValue})
                            input.onChange(newValue)
                        }
                    }}
                    modules={{
                        toolbar: toolbarOptions,
                        'emoji-toolbar': true,
                        'emoji-textarea': true,
                        'emoji-shortname': true,
                    }}
                />
            )
        }
    }
}

export default RichTextEditor
